import Slider from 'react-slick';
import { useTranslation } from 'react-i18next';

import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons';
import RatingBar from '../RatingBar/RatingBar';
import { reviews } from '../../../constants/const';
import { formatDate } from '../../../helpers/functions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import styles from './styles.module.scss';

const Reviews = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: true,
    autoplaySpeed: 5000,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    appendDots: (dots: any) => <div></div>,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const { t } = useTranslation();

  function SampleNextArrow(props: any) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: 'block' }}
        onClick={onClick}
      >
        <FontAwesomeIcon
          icon={faChevronRight}
          style={{ color: '#006633', fontSize: '28px' }}
        />
      </div>
    );
  }

  function SamplePrevArrow(props: any) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: 'block' }}
        onClick={onClick}
      >
        <FontAwesomeIcon
          icon={faChevronLeft}
          style={{ color: '#006633', fontSize: '28px' }}
        />
      </div>
    );
  }

  return (
    <div className={styles.reviews}>
      <div className={styles.container}>
        <div className={styles.wrapper}>
          <h2>{t('realReviews')}</h2>
          <div className={styles.sliderContainer}>
            <Slider {...settings}>
              {reviews.map((review) => (
                <div className={styles.sliderItem} key={review?.id}>
                  <RatingBar rating={review?.rating} />
                  <p className={styles.info}>
                    {review?.review}
                  </p>
                  <div className={styles.productWrapper}>
                    <div className={styles.userName}>{review?.name}</div>
                    <div className={styles.date}>{formatDate(review?.date)}</div>
                    <div className={styles.productImgWrapper}>
                      <img src={require(`../../../assets/images/products/grass/${review?.patchData?.imgSrc}`)} alt="" />
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reviews;
